module.exports = __webpack_public_path__ + "img/ground-floor-house-5.5c854a96.jpg";